import { useEffect, useRef } from "react";
import { signalRService, type DocumentStatusChangedPayload } from "@/services/signalr";

/**
 * Calls `onChange` when the server reports that a document's PandaDoc status changed. The server refreshes that status in the
 * background (a status read returns the stored one at once) and pushes this when it differs, so the page reads the status again.
 * Re-read only the status here: reloading the whole form would overwrite what the applicant is typing.
 */
export function useDocumentStatusPush(onChange: (payload: DocumentStatusChangedPayload) => void): void {
    const latest = useRef(onChange);

    useEffect(() => {
        latest.current = onChange;
    });

    useEffect(() => {
        const listener = (payload: DocumentStatusChangedPayload) => latest.current(payload);
        signalRService.onDocumentStatusChanged(listener);
        return () => signalRService.offDocumentStatusChanged(listener);
    }, []);
}
